// todo move this file to module
export const DeliveryOptions = {
    '0': 'هزینه ثابت',
    '1': 'هزینه پست محصول',
    '2': 'هزینه متغییر',
}
